var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStandardCardImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#C8D2F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3810_78405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1051 11.7606C28.9948 12.6997 30.2935 14.6498 30.2935 16.9032C30.2935 19.1566 28.9948 21.1066 27.1051 22.0458M29.6558 28.7212C31.5835 29.5935 33.3193 31.0151 34.7572 32.8452M9.25 32.8452C11.7325 29.6856 15.1029 27.7438 18.8152 27.7438C22.5276 27.7438 25.898 29.6856 28.3804 32.8452M24.5543 16.9032C24.5543 20.0728 21.9849 22.6423 18.8152 22.6423C15.6456 22.6423 13.0761 20.0728 13.0761 16.9032C13.0761 13.7336 15.6456 11.1641 18.8152 11.1641C21.9849 11.1641 24.5543 13.7336 24.5543 16.9032Z",
    stroke: "#122D8E",
    strokeWidth: 2.55072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3810_78405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3333,
    height: 29.3333,
    fill: "white",
    transform: "translate(7.33594 7.33594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardCardImage);
export default __webpack_public_path__ + "static/media/standard_card_image.356f02d954d27880a1be6b6839444ed9.svg";
export { ForwardRef as ReactComponent };